import React, { useEffect, useState } from "react";
import { FieldArray, FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
// import allowNumbersOnly from "../../CommonUtils/CommonValidations";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";
import AdmissionResultAnalysisReport from "./AdmissionResultAnalysisReport";
// import FinalcialResources from "./FinalcialResources";
const NewCourse = ({ typee }) => {
  const college=sessionStorage.getItem("user_id")
  const [program, setProgram] = useState([]);
  const [CourseCategory, setCourseCategory] = useState([]);
  const [course, setCourse] = useState([]);
  const [medium, setMedium] = useState([]);
  const [newStatus, setNewStatus] = useState(false);

  const initialValues = {
    newProgrammes: [
      {
        courseGropcode: "",
        courseType: "",
        courseId: "",
        proposed_intake: "",
        mediumCode: "",
        regSelf: "",
        courseNocType: "",
        aicteAppRef: "",
        amount: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    newProgrammes: Yup.array()
      .of(
        Yup.object().shape({
          courseGropcode: Yup.string().required(ERROR_MSG),
          courseType: Yup.string().required(ERROR_MSG),
          courseId: Yup.string().required(ERROR_MSG),
          // proposed_intake: Yup.string().required(ERROR_MSG),
          mediumCode: Yup.string().required(ERROR_MSG),
          regSelf: Yup.string().required(ERROR_MSG),
          courseNocType: Yup.string().required(ERROR_MSG),
          // aicteAppRef: Yup.string().required(ERROR_MSG),
        }),
      )
      .test("unique-combination", "Duplicate Course + Category + Program combination not allowed", function (value) {
        if (!value) return true;

        const combinations = value.map((item) => `${item.courseGropcode}_${item.courseType}_${item.courseId}`);

        const unique = new Set(combinations);

        if (unique.size !== combinations.length) {
          return this.createError({      //NOSONAR
            path: "newProgrammes",
            message: "Duplicate combination selected in rows",
          });
        }

        return true;
      }),
  });
  const newCourseFormik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save these New Course details?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            intakeType: "new",
            newcourselist: values.newProgrammes.map((item) => ({
              courseId: parseInt(item.courseId),
              proposedIntake: parseInt(item.proposed_intake),
              category: item.mediumCode,
              nature: "new",
              aicteRef: item.aicteAppRef,
              regSelf: item.regSelf,
              courseNocType: item.courseNocType,
              courseType: item.courseType,
              courseGropcode: item.courseGropcode,
              areaFee: item.amount || 0,
            })),
          };
          const url = `${config.url.FAC_URL}saveIntakeChanges`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc || "New Course Details Saved!",
                  icon: "success",
                  backdrop: false,
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.isConfirmed) {
                    GetNewCourseDetails();
                  }
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc || "Failed to save details",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error("Submission Error:", err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });

  function GetProgram() {
    let url = config.url.FAC_URL + `getCourseGroupList`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setProgram(res?.data?.getCourseGroupList);
      } else {
        setProgram([]);
      }
    });
  }
  // useEffect(() => {
  //   GetAmount()
  // }, []);
  const [getAmt, setAmt] = useState([]);
  // function GetAmount(value, index) {
  //   let url = config.url.FAC_URL + `getProgrammeFee?courseId=${value}`;
  //   CommonAxiosGet(url).then((res) => {
  //     if (res?.data?.scode === "01") {
  //       setAmt(res?.data?.amount);
  //     } else {
  //       setAmt([]);
  //     }
  //   });
  // }
  function GetAmount(value, index) {
    let url = config.url.FAC_URL + `getProgrammeFee?courseId=${value}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        const amountData = res?.data?.amount?.find(
          (item) => item.course_id == value
        );
        newCourseFormik.setFieldValue(
          `newProgrammes[${index}].amount`,
          amountData?.amount || 0
        );
      } else {
        newCourseFormik.setFieldValue(
          `newProgrammes[${index}].amount`,
          0
        );
      }
    });
  }
  function GetCourseCategory(program, index) {
    if (!program) {
      console.log("Invalid program value:", program);
      return;
    }

    try {
      // let url = `${config.url.FAC_URL}getCourseCategoryList/${program}`;
      let url = `${config.url.FAC_URL}courseCategoryForProgramintake/${program}`;

      CommonAxiosGet(url).then((res) => {
        if (res?.data?.scode === "01") {
          // let options = res?.data?.getCourseCategoryList?.map((ds, i) => (
          //   <option key={i} value={ds.course_cat_id}>
          //     {ds.course_cat_name}
          //   </option>
          // ));
          let options = res?.data?.getCourseCategoryList
            ?.filter((ds) =>
              ds.course_cat_name?.toLowerCase().includes("honours")
            )
            ?.map((ds, i) => (
              <option key={i} value={ds.course_cat_id}>
                {ds.course_cat_name}
              </option>
            ));
          setCourseCategory((prevState) => ({
            ...prevState,
            [index]: options,
          }));
        } else {
          setCourseCategory((prevState) => ({
            ...prevState,
            [index]: [],
          }));
        }
      });
    } catch (err) {
      console.error("Error fetching course categories:", err);
    }
  }
  //newly added

  const [courseData, setCourseData] = useState([]);

  function GetCourseDetails() {
    const url = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true && res?.data?.list?.length > 0) {
          setCourseData(res?.data?.list);
        } else {
          setCourseData([]);
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }


  //  ********** field array get api************
  const GetNewCourseDetails = () => {
    const url = `${config.url.FAC_URL}getInputDetails/new/${college}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01" && res.data.new.length > 0) {
          setNewStatus(res?.data?.new_status);
          const mappedData = res.data.new.map((item) => ({
            courseGropcode: item.course_group_code ?? "",
            courseType: item.course_type ?? "",
            courseId: item.course_id ?? "",
            proposed_intake: item.proposed_intake ?? "",
            mediumCode: item.category ?? "",
            regSelf: item.reg_self ?? "",
            courseNocType: item.course_noc_type ?? "",
            aicteAppRef: item.aicte_ref ?? "",
            amount: item.area_fee ?? "",
          }));

          newCourseFormik.setFieldValue("newProgrammes", mappedData);

          // ✅ ADD THIS BLOCK
          mappedData.forEach((item, index) => {
            if (item.courseGropcode) {
              GetCourseCategory(item.courseGropcode, index);
            }

            if (item.courseType) {
              GetCourses(item.courseType, index);
            }
          });
        } else {
          newCourseFormik.setFieldValue("newProgrammes", [
            {
              courseGropcode: "",
              courseType: "",
              courseId: "",
              proposed_intake: "",
              mediumCode: "",
              regSelf: "",
              courseNocType: "",
              aicteAppRef: "",
              amount: ""
            },
          ]);
        }
      })
      .catch((err) => {
        console.error("Error fetching new course details:", err);
      });
  };
  function GetCourses(CourseCategory, index) {
    if (!CourseCategory) {
      return;
    }
    try {
      let url = config.url.FAC_URL + `getSpecilization/${CourseCategory}`;
      CommonAxiosGet(url).then((res) => {
        if (res?.data?.scode === "01") {
          let options = res?.data?.Specilization?.map((ds, i) => {
            return (
              <option key={i} value={ds.course_id}>
                {ds.course_name}
              </option>
            );
          });
          setCourse((prevState) => ({
            ...prevState,
            [index]: options,
          }));
        } else {
          setCourse((prevState) => ({
            ...prevState,
            [index]: [],
          }));
        }
      });
    } catch (err) { }
  }

  function GetMediumList() {
    CommonAxiosGet(`${config.url.FAC_URL}getMediumList`).then((res) => {
      setMedium(res?.data?.scode === "01" ? res.data.getMediumList || [] : []);
    });
  }

  useEffect(() => {
    GetCourseDetails();
    GetProgram();
    GetNewCourseDetails();
    GetMediumList();


  }, []);
  const isDuplicateCombination = (values, currentIndex, field, newValue) => {
    const updatedRow = {
      ...values.newProgrammes[currentIndex],
      [field]: newValue,
    };

    // ✅ ignore incomplete rows
    if (!updatedRow.courseGropcode || !updatedRow.courseType || !updatedRow.courseId) {
      return false;
    }

    const newKey = `${updatedRow.courseGropcode}_${updatedRow.courseType}_${updatedRow.courseId}`;

    return values.newProgrammes.some((row, i) => {
      if (i === currentIndex) return false;

      if (!row.courseGropcode || !row.courseType || !row.courseId) {
        return false;
      }

      const key = `${row.courseGropcode}_${row.courseType}_${row.courseId}`;
      return key === newKey;

    });
  };
console.log("errrosssss111",newCourseFormik.errors)
  return (
    <>
      {/* FIRST TABLE */}
      <AdmissionResultAnalysisReport />
      <h5 className="mb-3 innerheader-new">
        <span>Program Details</span>
      </h5>
      

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-primary">
            <tr>
              <th> SL.No </th>
              <th> Academic Program Type</th>
              <th>Name of the Stream</th>
              <th>Name of the Single Major</th>
              <th>Medium</th>
              <th>Regular/Self Financed</th>
              <th>Permanent/Temporary</th>
              <th>Intake</th>
            </tr>
          </thead>
          <tbody>
            {courseData?.length > 0 ? (
              courseData?.map((course, index) => (
                <tr key={course.sno}>
                  <td>{index + 1}</td>
                  <td>{course.course_group_desc}</td>
                  <td>{course.course_cat_name}</td>
                  <td>{course.course_name}</td>
                  <td>{course.medium_name || course.medium_code || "-"}</td>
                  <td>{course.reg_self === "S" ? "Self Finance" : course.reg_self === "R" ? "Regular" : ""}</td>
                  <td>{course.course_noc_type}</td>
                  <td>{course.intake}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-danger fw-bold">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot className="table-secondary">
            <tr>
              <td colSpan="7" className="text-end fw-bold">Total Intake:</td>
              <td className="fw-bold text-center">
                {courseData.reduce((sum, course) => sum + (Number(course.intake) || 0), 0)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <h5 className="mb-3 innerheader-new">
        <span>New Program Details</span>
      </h5>
      <FormikProvider value={newCourseFormik}>
        <Form onSubmit={newCourseFormik.handleSubmit}>
          {typeof newCourseFormik.errors.newProgrammes === "string" && <div className="text-danger mb-2">{newCourseFormik.errors.newProgrammes}</div>}
          <div className="table-responsive ">
            <FieldArray name="newProgrammes">
              {(fieldArrayProps) => {
                const { push, remove } = fieldArrayProps;
                const { values } = newCourseFormik;
                return (
                  <table className="table table-bordered table-striped">
                    <thead className="table-primary">
                      <tr className="small text-uppercase">
                        <th className="text-center" width="60px">
                          Sl.No
                        </th>
                        <th width="250px">Academic Program Type</th>
                        {/* <th>Course /Program</th> */}
                        <th width="250px">Name of the Stream</th>
                        <th width="250px">Name of the Single Major</th>
                        <th>Medium</th>
                        <th>Regular/Self -Financed</th>
                        <th>Permanent/Temporary</th>

                        <th width="150px">Proposed Intake</th>

                        {/* <th>AICTE App. Ref.</th> */}
                        {/* <th>Approval Fee</th> */}
                        {/* <th>Type</th> */}
                        {/* {!newStatus && ( */}
                        <th className="text-center" width="100px">
                          Action
                        </th>
                        {/* )} */}
                      </tr>
                    </thead>
                    <tbody>
                      {values.newProgrammes.map((item, index) => (
                        <tr key={index}>
                          {console.log("item", item)}
                          <td className="text-center fw-bold text-muted">{index + 1}</td>
                          <td width="250px" >
                            <Field
                              as="select"
                              className="form-control"
                              name={`newProgrammes[${index}].courseGropcode`}

                              onChange={(e) => {
                                const value = e.target.value;

                                if (isDuplicateCombination(newCourseFormik.values, index, "courseGropcode", value)) {
                                  Swal.fire({
                                    icon: "warning",
                                    text: "This combination is already selected in another row",
                                  });
                                  return;
                                }

                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseGropcode`, value);
                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseType`, "");
                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseId`, "");

                                GetCourseCategory(value, index);
                              }}
                            >
                              <option value="">--Select--</option>
                              {/* {program.map((p, i) => (
                                <option key={i} value={p.course_group_code}>
                                  {p.course_group_desc}
                                </option>
                              ))} */}
                              {program
                                .filter((p) => p.course_group_desc === "DEGREE ACADEMIC")
                                .map((p, i) => (
                                  <option key={i} value={p.course_group_code}>
                                    {p.course_group_desc}
                                  </option>
                                ))}
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].courseGropcode`} component="div" className="text-danger small" />
                          </td>

                          {/* COURSE CATEGORY */}
                          <td width="250px">
                            <Field
                              as="select"
                              className="form-control"
                              name={`newProgrammes[${index}].courseType`}

                              onChange={(e) => {
                                const value = e.target.value;

                                if (isDuplicateCombination(newCourseFormik.values, index, "courseType", value)) {
                                  Swal.fire({
                                    icon: "warning",
                                    text: "This combination is already selected in another row",
                                  });
                                  return;
                                }

                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseType`, value);
                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseId`, "");

                                GetCourses(value, index);
                                let intake = "";

                                if (Number(value) === 81) {
                                  intake = "50";
                                } else if (Number(value) === 82) {
                                  intake = "60";
                                } else if (Number(value) === 83) {
                                  intake = "50";
                                }
                                else {
                                  intake = item.proposed_intake || item.intake

                                }
                                console.log("values", value)
                                newCourseFormik.setFieldValue(
                                  `newProgrammes[${index}].proposed_intake`,
                                  intake
                                );

                              }}
                            >
                              <option value="">--Select--</option>
                              {CourseCategory[index]}
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].courseType`} component="div" className="text-danger small" />
                          </td>

                          {/* COURSE */}
                          <td width="250px">
                            <Field
                              as="select"
                              className="form-control"
                              name={`newProgrammes[${index}].courseId`}

                              // onChange={(e) => {
                              //   const value = e.target.value;

                              //   if (isDuplicateCombination(newCourseFormik.values, index, "courseId", value)) {
                              //     Swal.fire({
                              //       icon: "warning",
                              //       text: "This combination is already selected in another row",
                              //     });
                              //     return;
                              //   }

                              //   newCourseFormik.setFieldValue(`newProgrammes[${index}].courseId`, value);
                              //   GetAmount(value, index);
                              //   const txt = e.target.options[e.target.selectedIndex]?.text || "";
                              //   console.log("Selected Text:", txt); 
                              //   let newIntake = "";
                              //   const normalized = txt.replace(/[\s\.]/g, "").toLowerCase();
                              //   if (normalized.includes("bschonours")) newIntake = "50";
                              //   if (normalized.includes("bahonours")) newIntake = "60";
                              //   if (normalized.includes("bcomhonours")) newIntake = "60";
                              //   if (newIntake) {
                              //     newCourseFormik.setFieldValue(`newProgrammes[${index}].proposed_intake`, newIntake);
                              //     console.log("Setting proposed_intake to", newIntake);  // debug
                              //   }
                              // }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (isDuplicateCombination(newCourseFormik.values, index, "courseId", value)) {
                                  Swal.fire({ icon: "warning", text: "This combination is already selected in another row" });
                                  return;
                                }
                                newCourseFormik.setFieldValue(`newProgrammes[${index}].courseId`, value);
                                GetAmount(value, index);


                                //   const txt = e.target.options[e.target.selectedIndex]?.text || "";
                                //   console.log("Selected Text:", txt);
                                //   const normalized = txt.replace(/[\s\.]/g, "").toLowerCase();
                                //   let newIntake = "";
                                //   if (normalized.includes("ba") && normalized.includes("honours")) newIntake = "60";
                                //   if (normalized.includes("bsc") && normalized.includes("honours")) newIntake = "50";
                                //   if (normalized.includes("bcom") && normalized.includes("honours")) newIntake = "60";
                                //   if (newIntake) {
                                //     newCourseFormik.setFieldValue(`newProgrammes[${index}].proposed_intake`, newIntake);
                                //     console.log("Set proposed_intake to", newIntake);
                                //   }
                              }}
                            >
                              <option value="">--Select--</option>
                              {course[index]}
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].courseId`} component="div" className="text-danger small" />
                          </td>

                          {/* MEDIUM */}
                          <td>
                            <Field as="select" className="form-control" name={`newProgrammes[${index}].mediumCode`} >
                              <option value="">--Select--</option>

                              {medium.map((m, i) => (
                                <option key={i} value={m.medium_code}>
                                  {m.name}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].mediumCode`} component="div" className="text-danger small" />
                          </td>

                          {/* REG / SELF */}
                          <td>
                            <Field as="select" className="form-control" name={`newProgrammes[${index}].regSelf`} >
                              <option value="">--Select--</option>
                              <option value="R">Regular</option>
                              <option value="S">Self-Financed</option>
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].regSelf`} component="div" className="text-danger small" />
                          </td>

                          {/* NOC TYPE */}
                          <td>
                            <Field as="select" className="form-control" name={`newProgrammes[${index}].courseNocType`} >
                              <option value="">--Select--</option>
                              <option value="Permanent">Permanent</option>
                              <option value="Temporary">Temporary</option>
                              <option value="Conditional">Conditional</option>
                            </Field>

                            <ErrorMessage name={`newProgrammes[${index}].courseNocType`} component="div" className="text-danger small" />
                          </td>
                          {/* Amount */}

                          {/* Proposed Intake */}
                          {/* {console.log("CourseCategory", CourseCategory)}
                          {console.log(
                            "courseId:",
                            newCourseFormik.values.newProgrammes[index]?.courseId
                          )} */}

                          <td>


                            {/* 
            "course_cat_name": "B.A.",
            "course_cat_id": 46
        },
        {
            "course_cat_name": "B A Honours",
            "course_cat_id": 81
        },
        {
            "course_cat_id": 85,
            "course_cat_name": "BAOL Honours"
        },
        {
            "course_cat_id": 3,
            "course_cat_name": "BCA"
        },
        {
            "course_cat_id": 87,
            "course_cat_name": "BCA Honours"
        },
        {
            "course_cat_id": 48,
            "course_cat_name": "B.Com"
        },
        {
            "course_cat_name": "B Com Honours",
            "course_cat_id": 82
        },
        {
            "course_cat_id": 5,
            "course_cat_name": "BCT and CA"
        },
        {
            "course_cat_name": "B Dance",
            "course_cat_id": 75
        },
        {
            "course_cat_name": "B Music",
            "course_cat_id": 74
        },
        {
            "course_cat_name": "BPA Honours",
            "course_cat_id": 89
        },
        {
            "course_cat_name": "B.SC",
            "course_cat_id": 50
        },
        {
            "course_cat_name": "B Sc Honours",
            "course_cat_id": 83
        },
        {
            "course_cat_name": "BSW",
            "course_cat_id": 51
        },
        {
            "course_cat_id": 54,
            "course_cat_name": "B.Vocational"
        },
        {
            "course_cat_id": 84,
            "course_cat_name": "B Voc Honours"
        }
    ],
    "data_count": 16
}} */}
                            <Field
                              name={`newProgrammes[${index}].proposed_intake`}
                              className="form-control form-control-sm text-end"
                              onKeyPress={allowNumbersOnly}
                              placeholder="0"
                              value={
                                Number(newCourseFormik.values.newProgrammes[index]?.courseType) === 81
                                  ? 60
                                  : Number(newCourseFormik.values.newProgrammes[index]?.courseType) === 82
                                    ? 60
                                    : Number(newCourseFormik.values.newProgrammes[index]?.courseType) === 83
                                      ? 50
                                      : Number(newCourseFormik.values.newProgrammes[index]?.courseType) === 84
                                        ? 50
                                        : 60
                              }
                            />
                            <ErrorMessage name={`newProgrammes[${index}].proposed_intake`} component="div" className="text-danger extra-small" />
                          </td>

                          {/* AICTE App Ref */}
                          {/* <td>
                            {
                              console.log(
                                "Selected Major:",
                                CourseCategory[index]
                                  ?.find(
                                    (c) =>
                                      c.props.value ===
                                      values.newProgrammes[index].courseType
                                  )
                                  ?.props.children
                              )
                            }
                            <Field name={`newProgrammes[${index}].aicteAppRef`} className="form-control form-control-sm" maxLength={50} placeholder="App. Ref."
                              disabled={
                                !["BBA Honours", "BCA Honours"].includes(
                                  CourseCategory[index]
                                    ?.find(
                                      (c) =>
                                        c.props.value ===
                                        values.newProgrammes[index].courseType
                                    )
                                    ?.props.children
                                )

                              } />
                            <ErrorMessage name={`newProgrammes[${index}].aicteAppRef`} component="div" className="text-danger extra-small" />
                          </td> */}

                          {/* <td> */}
                          {/* <Field name={`newProgrammes[${index}].amount`} className="form-control form-control-sm text-end" onKeyPress={allowNumbersOnly} value={getAmt[0]} disabled />
                             */}
                          <Field
                            name={`newProgrammes[${index}].amount`}
                            className="form-control form-control-sm text-end"
                            disabled type="hidden"
                          />
                          {/* </td> */}
                          {/* <td>{typee === "new" ? "New Ug Programme" : ""}</td> */}
                          {/* {!newStatus && ( */}
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              {index !== 0 && (
                                <jnb.Button variant="outline-danger" size="sm" className="btn-icon" onClick={() => remove(index)} title="Remove Row">
                                  <FaTrash />
                                </jnb.Button>
                              )}
                            </div>
                          </td>
                          {/* )} */}
                        </tr>
                      ))}
                    </tbody>
                    {/* TABLE FOOTER */}
                    {/* {!newStatus && ( */}
                    <tfoot className="faculty-table-footer">
                      <tr>
                        <td colSpan="12" className="text-end">
                          <jnb.Button
                            variant="success"
                            size="sm"
                            onClick={() => {
                              if (values.newProgrammes.length >= 3) {
                                Swal.fire({
                                  icon: "warning",

                                  text: "Only 3 courses are allowed. Please remove a course to add a new one.",
                                });
                                return;
                              }

                              push({
                                courseGropcode: "",
                                courseType: "",
                                courseId: "",
                                proposed_intake: "",
                                mediumCode: "",
                                regSelf: "",
                                courseNocType: "",
                                aicteAppRef: "",
                              })
                            }}
                          >
                            <FaPlusCircle className="me-2" />
                            Add Course
                          </jnb.Button>
                        </td>
                      </tr>
                    </tfoot>
                    {/* )} */}
                  </table>
                );
              }}
            </FieldArray>
          </div>

          {/* <AdmissionAndResultAnalysis  hide="true"/> */}

          {/* {!newStatus ? ( */}

          <jnb.Row className="mt-4">
            <jnb.Col>
              <div className="d-flex justify-content-end mt-4">
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
              </div>
            </jnb.Col>
          </jnb.Row>

          {/* <FinalcialResources formik={newCourseFormik}/> */}
          {/* ) : ( */}
          {/* <jnb.Row className="mt-4">
              <jnb.Col>
                <div className="d-flex justify-content-end mt-4">
                  <span className="text-success fw-bold">Already Submitted</span>
                </div>
              </jnb.Col>
            </jnb.Row> */}
          {/* // )} */}
        </Form>
      </FormikProvider>
    </>
  );
};

export default NewCourse;
